import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import STUDENT_FRAGMENT from 'graph/fragments/student';
import STUDENT_LICENSE_USAGE_FRAGMENT from 'graph/fragments/student-license-usage';
import CLASSROOM_LICENSE_USAGE_FRAGMENT from 'graph/fragments/classroom-license-usage';
import ORGANIZATION_LICENSE_USAGE from 'graph/fragments/license-usage';
import CLASSROOM_USER_ENROLLMENT_FRAGMENT from 'graph/fragments/classroom-user-enrollment';
import GROUPS_FRAGMENT from 'graph/fragments/groups';

const GET_CLASSROOM = gql`
  query getClassroom($id: Int!) {
    classroom(where: { id: $id }) {
      ...BaseClassroom
      licenseUsage {
        ...BaseClassroomLicenseUsage
      }
      organization {
        id
        ...OrganizationLicenseUsage
      }
      users {
        ...BaseClassroomUserEnrollment
      }
      students {
        ...BaseStudent
        licenseUsage {
          ...BaseStudentLicenseUsage
        }
        groups {
          ...BaseGroups
        }
      }
    }
  }
  ${CLASSROOM_USER_ENROLLMENT_FRAGMENT}
  ${CLASSROOM_FRAGMENT}
  ${CLASSROOM_LICENSE_USAGE_FRAGMENT}
  ${STUDENT_FRAGMENT}
  ${STUDENT_LICENSE_USAGE_FRAGMENT}
  ${ORGANIZATION_LICENSE_USAGE}
  ${GROUPS_FRAGMENT}
`;

export default GET_CLASSROOM;
